import {CategoryTypeVo} from '../api/nicolas/vo/enums/CategoryTypeVo.enum';

export function removeCategoryName(str: string, category: CategoryTypeVo) {
  const categoryName = REMOVE_CATEGORY_NAME_MAP[category];
  return categoryName ? str.replace(categoryName, '') : str;
}

const REMOVE_CATEGORY_NAME_MAP: {[key: number]: string | undefined} = {
  [CategoryTypeVo.Cartoon]: '만화',
  [CategoryTypeVo.Novel]: '소설',
};
